














































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import AppModal from './ui/Modal.vue';
import contestService from '@/modules/contests/services/ContestService';
import PlaceholderContent from '@/shared/components/ui/PlaceholderContent.vue';
import PlayerAvatar from "@/shared/components/ui/PlayerAvatar.vue";
import { pad } from "@/shared/utils";

@Component({
    components: {
        AppModal,
        PlaceholderContent,
        PlayerAvatar
    },
})
export default class JoinContest extends Vue {
    @Prop() open!: boolean;
    @Prop() contestId!: any;
    private selectedTab: string = 'summary';
    private contest: any = null;
    private players: any = [];
    private participants: any = [];

    close() {
       this.$emit('close');
    }

    private get formattedStartDate() {
        if (!this.contest || !this.contest.lineupChangesTime) {
            return ''
        }
        return (Vue as any).moment(this.contest.lineupChangesTime).format('YYYY-MM-DD');
    }

    private get contestStartCountdown() {
        if (!this.contest || !this.contest.lineupChangesTime) {
            return 0
        }

        const startsIn = new Date(this.contest.lineupChangesTime).getTime() - new Date().getTime();

        if (startsIn < 0) {
            return 0
        }

        return new Date(this.contest.lineupChangesTime).getTime() - new Date().getTime();
    }

    private get possibleProfit() {
        if (this.contest) {
            return (this.contest.moneyAmount * this.contest.maximumPlayers);
        }

        return 0;
    }

    private joinContest() {
        this.$emit('close');
        this.$emit('openPaymentModal')
    }

    private async mounted() {
        this.contest = await contestService.fetchContestDetails(this.contestId);
        this.participants  = this.contest.entries ? this.contest.entries.map((entry: any) => ({
            username: entry.user.name
        })) : [];
    }

    private get full() {
        if (!this.contest.entries) {
            return 0
        }
        if (this.contest) {
            return Math.floor((this.contest.entries.length / this.contest.maximumPlayers) * 100);
        }

        return 0;
    }

    private callPad(time: string) {
        return pad(time, 2)
    }
}
